<template>
  <div>
    <b-card>
      <template #header>
        <div>
          <h4>Satın Alma Talebi Stok Listesi</h4>
        </div>
        <div class="text-right">
          <b-button
            variant="primary"
            @click="addRow"
          >
            <feather-icon icon="PlusIcon" />
            Ekle
          </b-button>
        </div>
      </template>
      <!--      <b-row>-->
      <!--        <b-col-->
      <!--          cols="12"-->
      <!--          md="12"-->
      <!--        >-->
      <!--          <b-alert-->
      <!--            v-if="isAmountExceeded.status"-->
      <!--            show-->
      <!--            variant="warning"-->
      <!--            class="mt-2"-->
      <!--          >-->
      <!--            <div class="text-center alert-body">-->
      <!--              <feather-icon icon="InfoIcon" />-->
      <!--              {{ dataList.length }} ürün için girilen toplam adet ({{ isAmountExceeded.total |toNumber }}), teklif talebi için girilen toplam adet({{ dataItem.offer_amount | toNumber }}) sayısını geçiyor.-->
      <!--            </div>-->
      <!--          </b-alert>-->
      <!--        </b-col>-->
      <!--      </b-row>-->
      <template v-if="dataList.length < 1">
        <b-alert
          show
          variant="info"
          class="mt-2"
        >
          <div class="alert-body text-center">
            <div class="lead">
              Stok kaydı bulunamadı.
            </div>
            <div class="mt-1">
              <b-button
                variant="info"
                size="sm"
                @click="addRow"
              >
                Yeni Kayıt Oluştur
              </b-button>
            </div>
          </div>
        </b-alert>
      </template>
      <template v-else>
        <b-row
          v-for="(item, key) in dataList"
          :key="key"
          class="d-flex justify-content-center align-items-center"
        >
          <b-col>
            <purchase-item-stock-select :i-key="key" />
          </b-col>
          <b-col>
            <purchase-offer-item-amount :i-key="key" />
          </b-col>
          <b-col md="auto">
            <b-button
              variant="flat-danger"
              size="sm"
              class="mr-1"
              @click="removeData(key)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
            <b-button
              :disabled="dataList.length -1 !== key"
              variant="flat-success"
              size="sm"
              @click="addRow"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-card>
  </div>
</template>
<script>

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BRow, BCol, BAlert, BCard, BButton,
} from 'bootstrap-vue'
import PurchaseItemStockSelect from '@/views/Admin/Purchase_offers/Elements/Items/StockSelect.vue'
import PurchaseOfferItemAmount from '@/views/Admin/Purchase_offers/Elements/Items/StockAmountCard.vue'

export default {
  name: 'PurchaseOfferStocks',
  components: {
    PurchaseOfferItemAmount, PurchaseItemStockSelect, BRow, BCol, BAlert, BCard, BButton,
  },
  data() {
    return {

    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
    dataList() {
      return this.$store.getters['purchaseOfferItems/dataList']
    },
    isAmountExceeded() {
      const total = this.dataList.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
      return { status: total > Number(this.dataItem.offer_amount), total }
    },
  },
  created() {

  },
  methods: {
    addRow() {
      this.dataList.push({
        amount: null,
        id_stocks: null,
        id_purchase_offers: this.dataItem.id,
        units: null,
      })
    },
    removeData(key) {
      if (this.dataList[key].id) {
        this.$swal({
          title: this.$store.state.app.removeTitle,
          text: this.$store.state.app.removeMessage,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$store.state.app.removeConfirm,
          cancelButtonText: this.$store.state.app.removeCancel,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('purchaseOfferItems/removeData', this.dataList[key].id)
              .then(res => {
                if (res.status) {
                  this.$swal({
                    icon: 'success',
                    title: this.$store.state.app.removeResultTitle,
                    text: this.$store.state.app.removeResultMessage,
                    confirmButtonText: this.$store.state.app.removeResultClose,
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                  this.dataList.splice(key, 1)
                }
              })
          }
        })
      } else {
        this.dataList.splice(key, 1)
      }
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
